import client from '@services/TokenInterceptorServices';

export const getMslMyDashboardData = async (YEAR, ACCOUNT_ID, EMAIL, DATE) => {
  const URL = '/msl/dashboard/currentmetrics';
  const PAYLOAD = {
    email: EMAIL,
    year: YEAR,
    date: DATE,
    marketSegmentId: ACCOUNT_ID,
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getLiveForecastAccounts = async (
  MSLID,
  SUBMITTEDMONTH,
  SUBMITTEDFISCALYEAR,
  ROLLINGFISCALYEAR,
  ROLLINGMONTH,
  EMAIL,
  SEGMENT,
  NEXT,
  OFFSET,
) => {
  const URL = '/msl/forecast/accountdata';
  const PAYLOAD = {
    marketSegmentId: MSLID,
    submittedMonth: SUBMITTEDMONTH,
    submittedFiscalYear: SUBMITTEDFISCALYEAR,
    rollingFiscalYear: ROLLINGFISCALYEAR,
    rollingMonth: ROLLINGMONTH,
    email: EMAIL,
    accountSegment: SEGMENT,
    next: NEXT,
    offset: OFFSET,
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getMslYearlyMetrics = async (YEAR, SERVICE_LINE, ACCOUNT_ID, EMAIL, DATE) => {
  const URL = '/msl/dashboard/yearlymetrics';
  const PAYLOAD = {
    email: EMAIL,
    year: YEAR,
    date: DATE,
    marketSegmentId: ACCOUNT_ID,
    service: SERVICE_LINE === 'EMIA_ACR' ? 'emeia_acr' : SERVICE_LINE?.toLowerCase(),
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data[0];
};

export const getLiveForecastAccountSegments = async (
  EMAIL,
  MSLID,
  SUBMITTEDMONTH,
  SUBMITTEDFISCALYEAR,
  ROLLINGFISCALYEAR,
  ROLLINGMONTH,
) => {
  const URL = '/msl/forecast/accountsegment';
  const PAYLOAD = {
    email: EMAIL,
    marketSegmentId: MSLID,
    submittedMonth: SUBMITTEDMONTH,
    submittedFiscalYear: SUBMITTEDFISCALYEAR,
    rollingFiscalYear: ROLLINGFISCALYEAR,
    rollingMonth: ROLLINGMONTH,
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};
export const getMSLrollingFooterData = async (
  EMAIL,
  ROLLINGMONTH,
  ROLLINGYEAR,
  SUBMITTEDMONTH,
  SUBMITTEDYEAR,
  MSLID,
) => {
  const URL = '/msl/forecast/footer';
  const PAYLOAD = {
    email: EMAIL,
    rolling_month: ROLLINGMONTH,
    rolling_year: ROLLINGYEAR,
    submitted_month: SUBMITTEDMONTH,
    submitted_year: SUBMITTEDYEAR,
    market_segment_id: MSLID,
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const subHeaderMSLPastQtrDetails = async (QUARTER, YEAR, EMAIL) => {
  // Email Required *
  const URL = '/user/quarter';
  const PAYLOAD = { quarter: QUARTER, year: YEAR, email: EMAIL };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const subHeaderMSLPastMonthDetails = async (QUARTER, MONTH, YEAR, EMAIL) => {
  // Email Required *
  const URL = '/user/quarter';
  const PAYLOAD = { quarter: QUARTER, year: YEAR, month: MONTH, email: EMAIL };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getMSLPastOpportunitiesMonthly = async (
  EMAIL,
  ACCOUNT_ID,
  MONTH,
  YEAR,
  TYPE,
  QUARTER,
) => {
  const URL = '/msl/past/opportunities';
  const PAYLOAD = {
    email: EMAIL,
    account_id: ACCOUNT_ID,
    type: TYPE,
    year: YEAR,
    month: MONTH,
    quarter: QUARTER,
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getMSLPastOpportunitiesQuaterly = async (
  EMAIL,
  ACCOUNT_ID,
  MONTH,
  YEAR,
  TYPE,
  QUARTER,
) => {
  const URL = '/msl/past/opportunities';
  const PAYLOAD = {
    email: EMAIL,
    account_id: ACCOUNT_ID,
    type: TYPE,
    year: YEAR,
    month: 'null',
    quarter: QUARTER,
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const submitMSLopportunity = async REQ_BODY => {
  try {
    const URL = '/msl/submit/forecast';
    const PAYLOAD = REQ_BODY;
    const response = await client.post(URL, PAYLOAD);

    if (response?.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const submitMSLAggregateJudgeData = async (
  ACCOUNT_ID,
  EMAIL,
  MONTH,
  YEAR,
  QUARTER,
  REQ_BODY,
) => {
  const URL = '/msl/submit/judge';
  const RESPONSE = await client.post(URL, {
    account_id: ACCOUNT_ID,
    email: EMAIL,
    month: MONTH,
    year: YEAR,
    quarter: QUARTER,
    judge: REQ_BODY,
  });
  return RESPONSE.status === 200;
};

export const getMslGridData = async (
  EMAIL,
  ROLLINGMONTH,
  ROLLINGYEAR,
  SUBMITTEDMONTH,
  SUBMITTEDYEAR,
  MSLID,
) => {
  const URL = '/msl/forecast/footer';
  const PAYLOAD = {
    email: EMAIL,
    rolling_month: ROLLINGMONTH,
    rolling_year: ROLLINGYEAR,
    submitted_month: SUBMITTEDMONTH,
    submitted_year: SUBMITTEDYEAR,
    market_segment_id: MSLID,
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};

export const getPastMslGridData = async (
  EMAIL,
  MSLID,
  SUBMITTEDMONTH,
  SUBMITTEDYEAR,
  TYPE,
  QUARTER,
) => {
  const URL = '/msl/past-forecast/footer';
  const PAYLOAD = {
    email: EMAIL,
    market_segment_id: MSLID,
    month: SUBMITTEDMONTH,
    year: SUBMITTEDYEAR,
    type: TYPE,
    quarter: QUARTER,
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};
export const getPasMSLrollingOpportunities = async (
  EMAIL,
  MSLID,
  SUBMITTEDMONTH,
  SUBMITTEDFISCALYEAR,
  TYPE,
  QUARTER,
  MONTH,
) => {
  const URL = '/msl/past-forecast/accountsegment';
  const PAYLOAD = {
    email: EMAIL,
    marketSegmentId: MSLID,
    submittedMonth: SUBMITTEDMONTH,
    submittedFiscalYear: SUBMITTEDFISCALYEAR,
    month: MONTH,
    type: TYPE,
    quarter: QUARTER,
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};
export const getPastForecastAccounts = async (
  MSLID,
  SUBMITTEDMONTH,
  SUBMITTEDFISCALYEAR,
  EMAIL,
  SEGMENT,
  TYPE,
  QUARTER,
  NEXT,
  OFFSET,
) => {
  const URL = '/msl/past-forecast/accountdata';
  const PAYLOAD = {
    marketSegmentId: MSLID,
    submittedMonth: SUBMITTEDMONTH,
    submittedFiscalYear: SUBMITTEDFISCALYEAR,
    email: EMAIL,
    accountSegment: SEGMENT,
    type: TYPE,
    quarter: QUARTER,
    next: NEXT,
    offset: OFFSET,
  };
  const RESPONSE = await client.post(URL, PAYLOAD);
  return RESPONSE.data;
};
